import { useTranslation } from 'react-i18next'

import Page from '@/components/layouts/Page'
import { useAuth } from '@/features/authentication/contexts/AuthContext'
import { SiteSettingsView } from '@/features/site/components/settings/SiteSettingsView'
import { useSiteQuery } from '@/features/site/hooks/useSiteQuery'

export const SiteSettingsForRoUser = () => {
  const { loggedInUser } = useAuth()
  const { t } = useTranslation()

  const siteUuid = loggedInUser?.allowedRoIds?.[0] ?? ''

  const { site, isFetching, isFetched } = useSiteQuery(
    {
      uuid: siteUuid,
    },
    { enabled: Boolean(siteUuid) },
  )

  if (!site && isFetched) {
    return null
  }

  return (
    <Page
      isLoading={isFetching}
      pageHeaderProps={{
        pageTitle: t('component.page_header.settings'),
        pageTag: 'customer-settings-for-customer-user',
      }}
    >
      <SiteSettingsView site={site!} />
    </Page>
  )
}
